import React, { useEffect, useState } from "react";
import { isAndroid, isIPhone13, isMobile } from "react-device-detect";
import useTranslation from "../../hooks/useTranslation";
import { PlatformMobile } from "../../helpers/Constants";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogVentilaciones = ({
  icon,
  text,
  callbackConfirm,
  callbackCancel,
  status,
}) => {
  const T = useTranslation();
  const [isOpen, setIsOpen] = useState(status);

  const handlerCancel = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerOnConfirm = () => {
    if (callbackConfirm) {
      callbackConfirm();
    }
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  return (
    <>
      <FloatingDialog isOpen={isOpen} onClose={handlerCancel}>
        <div className="flex gap-[32px] flex-col items-center justify-center w-[100%]">
          {icon && (
            <div className="rounded flex items-center justify-center text-xl bg-[#2aac9c] w-[32px] h-[32px] text-white border">
              <img src={icon} className="w-full h-full" />
            </div>
          )}
          <span
            style={{
              maxWidth: PlatformMobile ? "80vw" : "430px",
              width: PlatformMobile ? "80vw" : "430px",
            }}
            className="font-bold text-center text-base text-[24px] "
          >
            {T(text)}
          </span>
          <div className="flex flex-wrap justify-center gap-4 w-full max-w-[450px]">
            <SimpleButton
              onClick={handlerCancel}
              text={T("No")}
              variant="gray"
            />
            <SimpleButton onClick={handlerOnConfirm} text={T("yes")} />
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogVentilaciones;
